import { render, staticRenderFns } from "./BrandEmblem.vue?vue&type=template&id=36ad1ab8&scoped=true"
import script from "./BrandEmblem.vue?vue&type=script&lang=js"
export * from "./BrandEmblem.vue?vue&type=script&lang=js"
import style0 from "./BrandEmblem.vue?vue&type=style&index=0&id=36ad1ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad1ab8",
  null
  
)

export default component.exports